// extracted by mini-css-extract-plugin
export default {"searchBox":"bp_g5","resultsOpen":"bp_g6"};